export default [
  {
    path: '/dashboard',
    name: 'A-Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
      pageTitle: 'Dashboard',
    },
  },
  {
    path: '/call/last',
    name: 'LastCall',
    component: () => import('@/views/administration/Call.vue'),
    meta: {
      resource: 'R600',
      action: 'read',
      pageTitle: 'letzer Anruf',
    },
  },
  {
    path: '/blank',
    name: 'Blank',
    component: () => import('@/views/blank.vue'),
    meta: {
      resource: 'R0',
      action: 'read',
      pageTitle: 'Blank',
    },
  },
  {
    path: '/stats/vehicle/:id',
    name: 'StatsVehicle',
    component: () => import('@/views/stats/VehicleStats.vue'),
    meta: {
      resource: 'R0',
      action: 'read',
      pageTitle: 'Fahrzeugstatistik',
    },
  },
  {
    path: '/billing',
    name: 'BillingList',
    component: () => import('@/views/billing/billingList.vue'),
    meta: {
      resource: 'R600',
      action: 'read',
      pageTitle: 'Rechnungen',
      breadcrumb: [
        {
          text: 'Rechnungen',
          active: true,
        },
      ],
    },
  },
  {
    path: '/billing/run',
    name: 'BillingRun',
    component: () => import('@/views/billing/billingRun.vue'),
    meta: {
      resource: 'R610',
      action: 'read',
      pageTitle: 'Neuer Rechnungslauf',
      breadcrumb: [
        {
          text: 'Rechnungen',
          active: true,
        },
      ],
    },
  },
  {
    path: '/voucher2/edit/:id',
    name: 'VoucherMask',
    component: () => import('@/views/voucher2/Voucher.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
    },
  },
  {
    path: '/map',
    name: 'Map',
    component: () => import('@/views/addressTemplate/Map.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
    },
  },
  {
    path: '/voucher2/:id/:type',
    name: 'VoucherMask',
    component: () => import('@/views/voucher2/Voucher.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
    },
  },
  {
    path: '/sumup',
    name: 'SumUp PayOuts',
    component: () => import('@/views/sumup/PayOuts.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
    },
  },
  {
    path: '/taxoffice',
    name: 'TaxOffice',
    component: () => import('@/views/administration/TaxOffice.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
    },
  },
  {
    path: '/taxoffice/giro',
    name: 'TaxofficeGiroList',
    component: () => import('@/views/taxoffice/Giro.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
    },
  },
  {
    path: '/taxoffice/cash',
    name: 'TaxofficeCashList',
    component: () => import('@/views/taxoffice/Cash.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
    },
  },
  {
    path: '/offer/:id/:type',
    name: 'OfferMask',
    component: () => import('@/views/voucher2/Voucher.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
    },
  },
  {
    path: '/add/offer',
    name: 'AddOfferMask',
    component: () => import('@/views/voucher2/Offer.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
    },
  },
  {
    path: '/add/offer2',
    name: 'AddOfferMask2',
    component: () => import('@/views/voucher2/Offer2.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
    },
  },
  {
    path: '/notepad',
    name: 'Notepad',
    component: () => import('@/views/notepad/NotePadList.vue'),
    meta: {
      resource: 'R2',
      action: 'read',
    },
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('@/views/dev/Chat.vue'),
    meta: {
      resource: 'R2',
      action: 'read',
    },
  },
  {
    path: '/voucher2/new',
    name: 'VoucherAdd',
    component: () => import('@/views/voucher2/Voucher.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Voucher Neu',
      breadcrumb: [
        {
          text: 'Neuer Voucher',
          active: true,
        },
      ],
    },
  },
  {
    path: '/voucher2/series',
    name: 'VoucherSeries',
    component: () => import('@/views/voucher2/VoucherSeries.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Neue Serie',
      breadcrumb: [
        {
          text: 'Neue Serie',
          active: true,
        },
      ],
    },
  },
  {
    path: '/voucherlist',
    name: 'Voucherlist',
    component: () => import('@/views/voucher2/VoucherList.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Voucher List',
      breadcrumb: [
        {
          text: 'Voucherübersichtslise',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ob',
    name: 'Ob',
    component: () => import('@/views/ob/Invoice.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'OB List',
      breadcrumb: [
        {
          text: 'OB - Voucherübersichtslise',
          active: true,
        },
      ],
    },
  },
  {
    path: '/mailvoucherlist',
    name: 'MailVoucherList',
    component: () => import('@/views/voucher2/MailVoucherList.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Voucher Parser List',
      breadcrumb: [
        {
          text: 'Voucherübersichtslise (Mail-Parser)',
          active: true,
        },
      ],
    },
  },
  {
    path: '/medicaltrips',
    name: 'MedicalTripList',
    component: () => import('@/views/voucher2/MedicalTripVoucherList.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Krankenfahrtenliste',
      breadcrumb: [
        {
          text: 'Krankenfahrtenliste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/serial/bookings',
    name: 'SerialBookingList',
    component: () => import('@/views/voucher2/SerialBookingList.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Serienfahrtenliste',
      breadcrumb: [
        {
          text: 'Serienfahrtenliste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/voucherlogs/:vid',
    name: 'VoucherLogList',
    component: () => import('@/views/voucher2/VoucherLogList.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Voucher List',
      breadcrumb: [
        {
          text: 'Voucherlogs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/mail/log',
    name: 'MailLogList',
    component: () => import('@/views/administration/MailLogList.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'MailLogList',
      breadcrumb: [
        {
          text: 'MailLogList',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account/log',
    name: 'AccountLogs',
    component: () => import('@/views/administration/AccountLogs.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'AccountLogs',
      breadcrumb: [
        {
          text: 'AccountLogs',
          active: true,
        },
      ],
    },
  },
  {
    path: '/customer/list',
    name: 'customerList',
    component: () => import('@/views/customer/CustomerList.vue'),
    meta: {
      resource: 'R700',
      action: 'read',
      requiresAuth: true,
      pageTitle: 'Kunden',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/customer/id/:id',
    name: 'customer',
    component: () => import('@/views/customer/Customer.vue'),
    meta: {
      resource: 'R710',
      action: 'read',
      pageTitle: 'Kunden',
      breadcrumb: [
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/flight/plans',
    name: 'FlightPlanList',
    component: () => import('@/views/flight/FlightPlanList.vue'),
    meta: {
      resource: 'R200',
      action: 'read',
      pageTitle: 'Flugpläne',
    },
  },
  {
    path: '/flight/plan/:id',
    name: 'FlightList',
    component: () => import('@/views/flight/FlightList.vue'),
    meta: {
      resource: 'R200',
      action: 'read',
      pageTitle: 'Flugplan',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/flight/:id',
    name: 'FlightEdit',
    component: () => import('@/views/flight/Flight.vue'),
    meta: {
      resource: 'R200',
      action: 'read',
      pageTitle: 'Flugplan (Anlegen))',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/call/list',
    name: 'CallList',
    component: () => import('@/views/administration/CallList.vue'),
    meta: {
      resource: 'R570',
      action: 'read',
      pageTitle: 'Anrufe',
      breadcrumb: [
        {
          text: 'liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/driver/voucher',
    name: 'DriverVoucher',
    component: () => import('@/views/administration/DriverVoucher.vue'),
    meta: {
      resource: 'R570',
      action: 'read',
      pageTitle: 'Fahrer Voucher',
      breadcrumb: [
        {
          text: 'liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/ki/pdf',
    name: 'KiPdf',
    component: () => import('@/views/administration/KiPdf.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
      pageTitle: 'Ki Pdf',
    },
  },
  {
    path: '/driver/invoice/:driver',
    name: 'DriverInvoice',
    component: () => import('@/views/administration/DriverInvoice.vue'),
    meta: {
      resource: 'R570',
      action: 'read',
      pageTitle: 'Fahrerabrechnung',
      breadcrumb: [
        {
          text: 'liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price/list',
    name: 'PriceList',
    component: () => import('@/views/administration/PriceList.vue'),
    meta: {
      resource: 'R630',
      action: 'read',
      pageTitle: 'Preise',
      breadcrumb: [
        {
          text: 'liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price/:identId',
    name: 'Price',
    component: () => import('@/views/administration/Price.vue'),
    meta: {
      resource: 'R630',
      action: 'read',
      pageTitle: 'Preis',
    },
  },
  {
    path: '/price/:identId/:type',
    name: 'Price',
    component: () => import('@/views/administration/Price.vue'),
    meta: {
      resource: 'R630',
      action: 'read',
      pageTitle: 'Preis',
    },
  },
  {
    path: '/drivers',
    name: 'Driver',
    component: () => import('@/views/administration/driver/DriverList.vue'),
    meta: {
      resource: 'R800',
      action: 'read',
      pageTitle: 'Fahrer',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/driver/:driver',
    name: 'DriverEdit',
    component: () => import('@/views/administration/driver/DriverEdit.vue'),
    meta: {
      resource: 'R800',
      action: 'read',
      pageTitle: 'Fahrer',
      breadcrumb: [
        {
          text: 'bearbeiten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/help/fix',
    name: 'FixHelper',
    component: () => import('@/views/help/Fix.vue'),
    meta: {
      resource: 'R0',
      action: 'read',
      pageTitle: 'Fehlerbehebung',
      breadcrumb: [],
    },
  },
  {
    path: '/taxoffice/voucher/create',
    name: 'CreateSevdeskVoucher',
    component: () => import('@/views/taxoffice/CreateSevdeskVoucher.vue'),
    meta: {
      resource: 'R800',
      action: 'read',
      pageTitle: 'Sevdesk Voucher',
      breadcrumb: [
        {
          text: 'erstellen',
          active: true,
        },
      ],
    },
  },
  {
    path: '/confirm/voucher',
    name: 'VoucherConfirm',
    component: () => import('@/views/voucher2/VoucherConfirm.vue'),
    meta: {
      resource: 'R500',
      action: 'read',
      pageTitle: 'Voucher',
      breadcrumb: [
        {
          text: 'Kontrolle Eingabe',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price/variation/list',
    name: 'PriceVariationList',
    resource: 'R0',
    action: 'read',
    component: () => import('@/views/addressTemplate/PriceVariationList.vue'),
    meta: {
      pageTitle: 'Preisvariationen',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/price/variation/edit/:id',
    name: 'PriceVariation',
    resource: 'R0',
    action: 'read',
    component: () => import('@/views/addressTemplate/PriceVariation.vue'),
    meta: {
      pageTitle: 'Preisvariation',
    },
  },
  {
    path: '/address',
    name: 'AddressTemplate',
    resource: 'R0',
    action: 'read',
    component: () => import('@/views/addressTemplate/AddressList.vue'),
    meta: {
      pageTitle: 'Adressliste',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/address/:id',
    name: 'Address',
    component: () => import('@/views/addressTemplate/Address.vue'),
    meta: {
      resource: 'R550',
      action: 'read',
    },
  },
  {
    path: '/dispo',
    name: 'DispositionList',
    component: () => import('@/views/disposition/DispositionList.vue'),
    meta: {
      resource: 'R400',
      action: 'read',
      pageTitle: 'Disposition',
    },
  },
  {
    path: '/dispo/:day',
    name: 'Disposition',
    component: () => import('@/views/disposition/Disposition.vue'),
    meta: {
      resource: 'R400',
      action: 'read',
      pageTitle: 'Disposition',

    },
  },
  {
    path: '/pdf/dispo/:day',
    name: 'Disposition',
    component: () => import('@/views/disposition/DispositionPdf.vue'),
    meta: {
      resource: 'R400',
      action: 'read',
      pageTitle: 'DispositionPdf',
      breadcrumb: [
        {
          text: 'Tag',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vehicles',
    name: 'Vehicle',
    resource: 'R820',
    action: 'read',
    component: () => import('@/views/administration/Vehicles.vue'),
    meta: {
      pageTitle: 'Fahrzeug',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/disposition/dispatch/:day',
    name: 'DispositionDispatch',
    resource: 'R400',
    action: 'read',
    component: () => import('@/views/disposition/DispositionDispatch.vue'),
    meta: {

    },
  },
  {
    path: '/check/price',
    name: 'PriceCheck',
    resource: 'R0',
    action: 'read',
    component: () => import('@/views/administration/PriceCheck.vue'),
    meta: {

    },
  },
  {
    path: '/mail/template/list',
    name: 'MailTemplateList',
    resource: 'R50',
    action: 'read',
    component: () => import('@/views/administration/MailTemplateList.vue'),
    meta: {
      pageTitle: 'E-Mail Template',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/mail/template/edit/:id',
    name: 'MailTemplateEdit',
    resource: 'R50',
    action: 'read',
    component: () => import('@/views/administration/MailTemplateEdit.vue'),
    meta: {
      pageTitle: 'E-Mail Template',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/logs',
    name: 'Logs',
    resource: 'R10',
    action: 'read',
    component: () => import('@/views/administration/Logs.vue'),
    meta: {
      pageTitle: 'Logs',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/system/logs',
    name: 'SystemLogs',
    resource: 'R30',
    action: 'read',
    component: () => import('@/views/administration/SystemLogs.vue'),
    meta: {
      pageTitle: 'Logs',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pdf/queue/logs',
    name: 'PdfQueueLogList',
    resource: 'R30',
    action: 'read',
    component: () => import('@/views/administration/PdfQueueLogList.vue'),
    meta: {
      pageTitle: 'PdfQueueLogList',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import('@/views/user/Account.vue'),
    meta: {
      resource: 'R0',
      action: 'read',
      pageTitle: 'Account',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/pushover',
    name: 'Pushover',
    component: () => import('@/views/administration/Pushover.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
      pageTitle: 'Pushover',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/users',
    name: 'Users',
    component: () => import('@/views/administration/UserList.vue'),
    meta: {
      resource: 'R10',
      action: 'read',
      pageTitle: 'Benutzer',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/add',
    name: 'AddUser',
    component: () => import('@/views/administration/UserAdd.vue'),
    meta: {
      pageTitle: 'Benutzer',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user/edit/:id',
    name: 'User',
    component: () => import('@/views/administration/UserAdd.vue'),
    meta: {
      pageTitle: 'Benutzer',
      breadcrumb: [
        {
          text: 'Verwalten',
          active: true,
        },
      ],
    },
  },
  {
    path: '/second-page',
    name: 'second-page',
    component: () => import('@/views/SecondPage.vue'),
    meta: {
      pageTitle: 'Second Page',
      breadcrumb: [
        {
          text: 'Second Page',
          active: false,
        },
      ],
    },
  },
  {
    path: '/update',
    name: 'update',
    component: () => import('@/views/Update.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/tab/:day',
    name: 'tab',
    component: () => import('@/views/tab/tabpage.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/dc/:id/:date/:code',
    name: 'DriverConfirm',
    component: () => import('@/views/DriverConfirm.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/pickup/viewer',
    name: 'PickupViewer',
    component: () => import('@/views/PickupViewer.vue'),
    meta: {
      pageTitle: 'Pickups',
      breadcrumb: [
        {
          text: 'Liste',
          active: false,
        },
      ],
    },
  },
  {
  path: '/kalender',
  name: 'Kalender',
  component: () => import('@/views/calendar/CalendarView.vue')
  },
  {
  path: "/invoice/run/local",
  name: "InvoiceRunLocal",
  component: () => import("@/views/billing/InvoiceRunLocal.vue"),
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/error-500',
    name: 'error-500',
    component: () => import('@/views/error/Error500.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]
